module.exports = __webpack_public_path__ + "img/53.4.NH3-N.e9263da7.png";